export enum Roles {
  superAdmin = 'super_admin',
  admin = 'admin',
  participant = 'participant',
  public = 'public',
}
